// extracted by mini-css-extract-plugin
export var searchHeader = "_6o-0";
export var searchHeaderDark = "_6o-1";